import { Input, type InputVariantProps } from "@overmap-ai/blocks"
import { type FocusEventHandler, memo, useCallback } from "react"

import { useBlurInput } from "../../../hooks/utils"
import { useFallbackEditor, useTextStyleState } from "../../hooks"
import type { OptionalEditorProps } from "../typings"

interface FontSizeInputProps extends OptionalEditorProps, InputVariantProps {}

export const FontSizeInput = memo<FontSizeInputProps>((props) => {
	const { editor: editorFromProps, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const { fontSize = "16px" } = useTextStyleState(editor)

	const handleBlur = useCallback<FocusEventHandler<HTMLInputElement>>(
		(e) => {
			const value = parseInt(e.target.value)
			if (isNaN(value)) return
			editor?.chain().focus().setFontSize(`${value}px`).run()
		},
		[editor],
	)

	const { value, onChange, onBlur } = useBlurInput(parseInt(fontSize).toString(), handleBlur)

	return (
		<Input.Root {...rest}>
			<Input.Field
				className="px-2! w-10 text-center"
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				type="text"
			/>
		</Input.Root>
	)
})
FontSizeInput.displayName = "FontSizeInput"
